import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, ResponsiveContainer
} from 'recharts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { BryButton } from '../../UI/BryUI';

export const AdminWeeklyChart = ({ chartData, onExportCSV }) => {
  return (
    <div
      className="p-4 rounded-4 shadow-lg mb-4"
      style={{
        backgroundColor: 'rgba(20, 20, 20, 0.95)',
        border: '1px solid rgba(14, 171, 176, 0.25)'
      }}
    >
      <div className="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom border-secondary border-opacity-25">
        <div>
          <h5 className="text-white fw-bold mb-0">Rendimiento de los Últimos 7 Días</h5>
          <span className="text-white-50 small">Comparativa de ingresos totales y comisiones de plataforma</span>
        </div>
        <BryButton
          variant="secondary"
          size="sm"
          onClick={onExportCSV}
          style={{ borderColor: 'var(--bry-accent, #0EABB0)', color: '#ffffff' }}
        >
          <FontAwesomeIcon icon={faDownload} className="me-2" /> Exportar CSV
        </BryButton>
      </div>

      <div style={{ width: '100%', height: 300 }}>
        <ResponsiveContainer width="100%" height="100%" minWidth={0} minHeight={250}>
          <BarChart data={chartData} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255, 255, 255, 0.08)" />
            <XAxis dataKey="name" stroke="rgba(255, 255, 255, 0.5)" tick={{ fontSize: 12 }} />
            <YAxis stroke="rgba(255, 255, 255, 0.5)" tick={{ fontSize: 12 }} />
            <RechartsTooltip
              contentStyle={{
                backgroundColor: '#111111',
                borderColor: 'var(--bry-accent, #0EABB0)',
                borderRadius: '12px',
                color: '#ffffff'
              }}
            />
            <Bar dataKey="Ingresos" fill="var(--bry-accent, #0EABB0)" radius={[6, 6, 0, 0]} />
            <Bar dataKey="Comisiones" fill="#F59E0B" radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default AdminWeeklyChart;
